import { render, staticRenderFns } from "./ModificarCobranzasForm.vue?vue&type=template&id=4eb688db&scoped=true"
import script from "./ModificarCobranzasForm.vue?vue&type=script&lang=js"
export * from "./ModificarCobranzasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb688db",
  null
  
)

export default component.exports